import { render, staticRenderFns } from "./InsMenu.vue?vue&type=template&id=873db89c&scoped=true&"
import script from "./InsMenu.vue?vue&type=script&lang=ts&"
export * from "./InsMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873db89c",
  null
  
)

export default component.exports